import FinderBreadcrumbs from "./FinderBreadcrumbs";

export default FinderBreadcrumbs;
